import BookmarkToggle from 'blacklight-frontend/bookmark_toggle'
import ButtonFocus from 'blacklight-frontend/button_focus'
import ColorThemeSwitcher from 'blacklight-frontend/color_theme_switcher'
import FacetSuggest from 'blacklight-frontend/facet_suggest'
import Modal from 'blacklight-frontend/modal'
import SearchContext from 'blacklight-frontend/search_context'
import Core from 'blacklight-frontend/core'

export default {
  BookmarkToggle,
  ButtonFocus,
  ColorThemeSwitcher,
  FacetSuggest,
  Modal,
  SearchContext,
  Core,
  onLoad: Core.onLoad
}
